import { apiGet, apiPost, apiPatch, apiDelete } from "../shared/apiClient";

export interface TeamUserRef { _id: string; name: string; email: string; avatar?: string }
export interface TeamRole { _id: string; name: string; permissions: string[]; isDefault: boolean }
export interface TeamMember {
  _id: string;
  userId: TeamUserRef | string;
  roleId: TeamRole | string;
  monthlyCap?: number;
  creditsUsed: number;
  joinedAt: string;
}
export interface Seats {
  memberCount: number;
  pendingInvites: number;
  maxMembers: number;
  workspaceName: string;
  planName: string | null;
}
export interface MembersResponse {
  members: TeamMember[];
  ownerId: string;
  seats: Seats;
}
export interface TeamInvite {
  _id: string;
  email: string;
  roleId: { _id: string; name: string } | string;
  status: "pending" | "accepted" | "expired" | "revoked";
  token: string;
  expiresAt: string;
  invitedBy?: { name: string; email: string } | string;
  createdAt: string;
}

export const listMembers = () => apiGet<MembersResponse>("/team/members");
export const updateMember = (id: string, patch: { roleId?: string; monthlyCap?: number }) =>
  apiPatch<TeamMember>(`/team/members/${id}`, patch);
export const removeMember = (id: string) => apiDelete<null>(`/team/members/${id}`);

export const listRoles = () => apiGet<TeamRole[]>("/team/roles");
export const createRole = (name: string, permissions: string[]) =>
  apiPost<TeamRole>("/team/roles", { name, permissions });
export const updateRole = (id: string, patch: { name?: string; permissions?: string[] }) =>
  apiPatch<TeamRole>(`/team/roles/${id}`, patch);
export const deleteRole = (id: string) => apiDelete<null>(`/team/roles/${id}`);

export const listInvites = () => apiGet<TeamInvite[]>("/team/invites");
export const createInvite = (email: string, roleId: string) =>
  apiPost<TeamInvite>("/team/invites", { email, roleId });
export const revokeInvite = (id: string) => apiPatch<TeamInvite>(`/team/invites/${id}/revoke`);
export const acceptInvite = (token: string) =>
  apiPost<{ workspaceId: string; workspaceName?: string; workspaceSlug?: string }>(`/team/invites/accept/${token}`);

/** Management permissions relevant to Vault (gen.* AI perms are not used here). */
export const VAULT_PERMISSIONS: { key: string; label: string; hint: string }[] = [
  { key: "mgmt.library.view", label: "View models", hint: "See the workspace's 3D models" },
  { key: "mgmt.library.download", label: "Download", hint: "Download GLB/source files" },
  { key: "mgmt.library.delete", label: "Delete models", hint: "Remove models from the Vault" },
  { key: "mgmt.library.view_others", label: "View others' models", hint: "See models created by other members" },
  { key: "mgmt.transactions.view", label: "View usage", hint: "See embed views / usage" },
  { key: "mgmt.team.invite", label: "Manage team", hint: "Invite members, manage roles" },
  { key: "mgmt.billing.manage", label: "Manage billing", hint: "Change plan, manage subscription" },
];
